module.exports = __webpack_public_path__ + "img/img6.25277a75.svg";